// 成品信息管理
<template>
    <div class="main">
        <el-row :gutter="10" class="mar_tb">
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="icon iconfont icon-danju-xiugai-tianchong" style="margin-right:2px;"></i>
                        <span style="font-size:13px;">珠宝饰品信息</span>
                    </div>
                    <div class="search-content mar_b" style="margin-bottom:-15px;">
                        <el-form :inline="true" label-width="100px" size="mini" 
                            :model="query" class="demo-form-inline" ref="query">
                            <el-form-item prop="stock_id" label="货号：">
                                <el-input v-model="query.stock_id" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="produce_name" label="名称：" label-width="60px">
                                <el-input v-model="query.produce_name" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="shape" label="形状：" label-width="60px">
                                <el-input v-model="query.shape" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="fenshu" label="大小：" label-width="60px">
                                <el-input v-model="query.fenshu" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="material" label="材质：" label-width="60px">
                                <el-input v-model="query.material" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="type" label="品类：" label-width="60px">
                                <el-input v-model="query.type" placeholder="请输入"></el-input>
                            </el-form-item>
                            <!--
                            <el-form-item prop="type" label="品类：" label-width="60px">
                                <el-select v-model="query.type" placeholder="请选择" clearable>
                                    <el-option v-for="item in typeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item></br>
                            -->
                            <el-form-item prop="place" label="地点：" label-width="90px">
                                <el-checkbox-group v-model="checkboxGroup12" size="small" @change="checkboxChange12">
                                    <el-checkbox-button v-for="item in placeList" :label="item.value" :key="item.value">{{item.value}}</el-checkbox-button>
                                </el-checkbox-group>
                                <!--
                                <el-select v-model="query.place" placeholder="请选择" clearable style="width:220px">
                                    <el-option v-for="item in placeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                                -->
                            </el-form-item>
                            <el-form-item prop="sale_status" label="状态：" label-width="90px">
                                <el-checkbox-group v-model="checkboxGroup9" size="small" @change="checkboxChange9">
                                    <el-checkbox-button v-for="item in sale_statusList" :label="item.value" :key="item.value">{{item.value}}</el-checkbox-button>
                                </el-checkbox-group>
                            </el-form-item>
                            <el-form-item prop="clients" label="客户：" label-width="90px">
                                <el-input v-model="query.clients" placeholder="请输入" style="width:220px"></el-input>
                            </el-form-item>
                            <el-form-item prop="remark" label="备注：" label-width="90px">
                                <el-input v-model="query.remark" placeholder="请输入" style="width:220px"></el-input>
                            </el-form-item>
                            <el-form-item class="search-but" style="float:right;margin-right:200px">
                                <el-button type="primary" @click="selectList">查询</el-button>
                                <el-button @click="resetForm('query')">重置</el-button>
                            </el-form-item><br>
                        </el-form>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <div class="text e-info auto-table">
                        <el-button type="primary" @click="selectCertno" size="small" :disabled="isAble">获取货号</el-button>
                        <el-button type="primary" @click="exportSelect" :disabled="isAble" size="small">导出选中</el-button>
                        <el-button type="primary" @click="exportAllList" size="small">导出全部</el-button>
                        <el-button type="success" @click="dialogTableVisible001 = true" size="small">上传货品</el-button>
                        <el-button type="primary" @click="insertProduceInfo" size="small">新增货品</el-button>
                        <el-button type="primary" @click="dialogTableVisible2 = true" size="small" :disabled="isAble">批量更新</el-button>
                        <el-button type="warning" @click="dialogTableVisible8 = true" size="small" :disabled="isAble" v-if="usertype==='2' || usertype==='4'">删除选中<i class="el-icon-delete el-icon--right"></i></el-button>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="10" class="mar_tb" sytle="height:30px">
            <el-col :span="24">
                <el-card class="box-card">
                    <!--分页-->
                    <div class="block tar mar_t">
                        <div class="text e-info auto-table">
                            <span style='float:left;font-size:18px'> 已选：{{data_len}} </span>
                        </div>
                        <el-pagination @size-change="sizeChange" @current-change="pageChange" :current-page="pager.page"
                                       :page-sizes="[20, 50, 100, 200]" :page-size="pager.rows"
                                       layout="total,sizes, prev, pager, next, jumper"
                                       :total="pager.total"></el-pagination>
                    </div>
                    <div class="text e-info auto-table">
                        <el-table :data="produceInfoList" stripe size="mini" height='600px'
                            @selection-change="selectionLineChangeHandle" ref="refTable"
                            :header-cell-style="{background:'#eef1f6',color:'#606266'}">
                            <el-table-column type="selection" align="center" width="40"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="image_link" label="图片" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div>
                                    <!--
                                    <el-image fit="contain" style="height:20px" v-if="scope.row.image_link !== '' || !scope.row.vedio_link" lazy
                                        :src="scope.row.image_link" :preview-src-list="[scope.row.image_link]">
                                    </el-image>
                                    -->
                                    <div style="display:flex;justify-content:center;gap:8px">
                                        <i v-if="scope.row.image_link" class="el-icon-picture" 
                                            style="font-size:20px;color:#409EFF;cursor:pointer"
                                            @click="openImageDialog(scope.row.image_link)"></i>
                                    </div>
                                    <div v-if="scope.row.vedio_link" @click="openVideoDialog(scope.row.vedio_link)" style="cursor:pointer">
                                        <i class="el-icon-video-camera" style="font-size: 20px; color: #409EFF;"></i>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                            <el-table-column align="center" min-width="14%" prop="stock_id" label="货号" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <el-button type="text" @click="handleStockIdClick(scope.row)">{{ scope.row.stock_id }}</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" min-width="11%" prop="produce_name" label="名称"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="type" label="品类"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="length" label="尺寸"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="material" label="材质"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="shape" label="形状"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="fenshu" label="大小"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="produce_detail" label="详细参数"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="weight" label="总重"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="net_weight" label="净重"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="diamond_weight" label="钻石总重"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="diamond_num" label="钻石数量"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="gold" label="金价" v-if="usertype==='2' || usertype==='4'"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="loss" label="损耗" v-if="usertype==='2' || usertype==='4'"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="gold_price" label="金料金额" v-if="usertype==='2' || usertype==='4'"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="point" label="其他费用" v-if="usertype==='2' || usertype==='4'"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="diamond_cost" label="裸石成本" v-if="usertype==='2' || usertype==='4'"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="diamond_price" label="裸石价格" v-if="usertype==='2' || usertype==='4'"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="rings_cost" label="戒托成本" v-if="usertype==='2' || usertype==='4'"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="rings_price" label="戒托价格" v-if="usertype==='2' || usertype==='4'"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="rmb_cost" label="成本" v-if="usertype==='2' || usertype==='4'"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="sale_price" label="售价"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="place" label="地点"></el-table-column>
                            <el-table-column align="center" min-width="6%" prop="sale_status" label="状态"></el-table-column>
                            <el-table-column align="center" min-width="8%" prop="clients" label="客户"></el-table-column>
                            <el-table-column align="center" min-width="10%" prop="remark" label="备注"></el-table-column>
                            <el-table-column align="center" min-width="9%" prop="upload_date" label="上架日期"></el-table-column>
                            <el-table-column align="center" min-width="10%" prop="caozuo" label="操作"  v-if="usertype==='2' || usertype==='4'">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="mini"
                                        @click="selectProduceList(scope.row)" >修改</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <div class="text e-info auto-table">
            <el-dialog title="修改信息" :visible.sync = "dialogTableVisible10" @close="closeSava" 
                center :close-on-click-modal="false" width="1000px">
                <el-form :inline="true" label-width="110px" size="mini" :model="addDataForm" 
                        class="demo-form-inline" ref="addDataForm" :rules="rules">
                    <el-form-item prop="stock_id" label="货号：">
                        <el-input style="width:180px;" v-model="addDataForm.stock_id" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="type" label="品类：">
                        <el-select v-model="addDataForm.type" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in typeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item><br>
                    <el-form-item prop="produce_name" label="名称：">
                        <el-input style="width:180px;" v-model="addDataForm.produce_name" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="shape" label="形状：">
                        <el-input style="width:180px;" v-model="addDataForm.shape" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="fenshu" label="大小：">
                        <el-input style="width:180px;" v-model="addDataForm.fenshu" placeholder="请输入"></el-input>
                    </el-form-item></br>
                    <el-form-item prop="length1" label="尺寸：">
                        <el-input style="width:180px;" v-model="addDataForm.length" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="material" label="材质：">
                        <el-input style="width:180px;" v-model="addDataForm.material" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="place" label="地点：">
                        <el-input style="width:180px;" v-model="addDataForm.place" placeholder="请输入"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="produce_detail" label="详细参数：">
                        <el-input style="width:180px;" v-model="addDataForm.produce_detail" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="diamond_weight" label="钻石总重：">
                        <el-input style="width:180px;" v-model="addDataForm.diamond_weight" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="diamond_num" label="钻石数量：">
                        <el-input style="width:180px;" v-model="addDataForm.diamond_num" placeholder="请输入"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="weight" label="总重：">
                        <el-input style="width:180px;" v-model="addDataForm.weight" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="net_weight" label="净重：">
                        <el-input style="width:180px;" v-model="addDataForm.net_weight" placeholder="请输入"
                        oninput="value=value.replace(/[^-0-9.]/g,'')" @input="handleInput1"></el-input>
                    </el-form-item>
                    <el-form-item prop="loss" label="损耗：">
                        <el-input style="width:180px;" v-model="addDataForm.loss" placeholder="请输入"
                            oninput="value=value.replace(/[^-0-9.]/g,'')" @input="handleInput1"></el-input>
                    </el-form-item>
                    <br>
                    <el-form-item prop="gold" label="金价：">
                        <el-input style="width:180px;" v-model="addDataForm.gold" placeholder="请输入" 
                            oninput="value=value.replace(/[^-0-9.]/g,'')" @input="handleInput1"></el-input>
                    </el-form-item>
                    <el-form-item prop="gold_price" label="金料金额：">
                        <el-input style="width:180px;" v-model="addDataForm.gold_price" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="point" label="其他费用：">
                        <el-input style="width:180px;" v-model="addDataForm.point" placeholder="请输入"
                            oninput="value=value.replace(/[^-0-9.]/g,'')" @input="handleInput1"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="diamond_cost" label="裸石成本：">
                        <el-input style="width:180px;" v-model="addDataForm.diamond_cost" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="diamond_price" label="裸石价格：">
                        <el-input style="width:180px;" v-model="addDataForm.diamond_price" placeholder="请输入"
                            oninput="value=value.replace(/[^-0-9.]/g,'')" @input="handleInput2"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="rings_cost" label="戒托成本：">
                        <el-input style="width:180px;" v-model="addDataForm.rings_cost" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="rings_price" label="戒托价格：">
                        <el-input style="width:180px;" v-model="addDataForm.rings_price" placeholder="请输入"
                            oninput="value=value.replace(/[^-0-9.]/g,'')" @input="handleInput2"></el-input>
                    </el-form-item><br>
                    <el-form-item prop="rmb_cost">
                        <template slot="label">
                            <span>成本：</span>
                            <el-tooltip content="成本=裸石价格+戒托价格" placement="top">
                                <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: pointer;"></i>
                            </el-tooltip>
                        </template>
                        <el-input style="width:180px;" v-model="addDataForm.rmb_cost" placeholder="请输入"
                            oninput="value=value.replace(/[^-0-9.]/g,'')" @input="handleInput3"></el-input>
                    </el-form-item>
                    <el-form-item prop="sale_price">
                        <template slot="label">
                            <span>售价：</span>
                            <el-tooltip content="售价=成本*1.15" placement="top">
                                <i class="el-icon-question" style="margin-left: 4px; color: #909399; cursor: pointer;"></i>
                            </el-tooltip>
                        </template>
                        <el-input style="width:180px;" v-model="addDataForm.sale_price" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="sale_status" label="状态：">
                        <el-select v-model="addDataForm.sale_status" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in sale_statusList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item><br>
                    <el-form-item prop="clients" label="客户：">
                        <el-input style="width:180px;" v-model="addDataForm.clients" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="upload_date" label="上架日期：">
                        <el-date-picker style="width:180px;" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="addDataForm.upload_date"></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="deal_date" label="完成日期：">
                        <el-date-picker style="width:180px;" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" v-model="addDataForm.deal_date"></el-date-picker>
                    </el-form-item><br>
                    <el-form-item prop="remark" label="备注：">
                        <el-input type="textarea" :autosize="{minRows:6, maxRows:3}" style="width:500px;"
                            placeholder="请输入内容" v-model="addDataForm.remark">
                        </el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="closeSava">取 消</el-button>
                    <el-button type="primary" @click="savaInfo">保 存</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="货品详情" :visible.sync="stockIdDialogVisible" @close="closeStockIdDialog" 
                center :close-on-click-modal="false" width="1400px">
                <el-form :inline="true" label-width="110px" size="mini" :model="stockIdForm" 
                        class="demo-form-inline" ref="stockIdForm">
                    <el-form-item label="货号：">
                        <span>{{ stockIdForm.stock_id }}</span>
                    </el-form-item>
                    <el-form-item label="名称：">
                        <span>{{ stockIdForm.produce_name }}</span>
                    </el-form-item>
                    <!--
                    <el-form-item label="形状：">
                        <span>{{ stockIdForm.shape }}</span>
                    </el-form-item>
                    <el-form-item label="大小：">
                        <span>{{ stockIdForm.fenshu }}</span>
                    </el-form-item>
                    -->
                    <el-form-item label="地点：">
                        <span>{{ stockIdForm.place }}</span>
                    </el-form-item>
                    <el-form-item label="售价：">
                        <span>{{ stockIdForm.sale_price }}</span>
                    </el-form-item>
                    <el-form-item label="总重：">
                        <span>{{ stockIdForm.weight }}</span>
                    </el-form-item>
                    <el-form-item label="净重：">
                        <span>{{ stockIdForm.net_weight }}</span>
                    </el-form-item>
                    <el-form-item label="品类：">
                        <span>{{ stockIdForm.type }}</span>
                    </el-form-item>
                    <!--
                    <el-form-item label="尺寸：">
                        <span>{{ stockIdForm.length }}</span>
                    </el-form-item>
                    -->
                    <el-form-item label="材质：">
                        <span>{{ stockIdForm.material }}</span>
                    </el-form-item>

                    <el-form-item label="钻石数量：">
                        <span>{{ diamond_num }}</span>
                    </el-form-item>
                    <!--
                    <el-form-item label="金价：">
                        <span>{{ stockIdForm.gold }}</span>
                    </el-form-item>
                    <el-form-item label="金料金额：">
                        <span>{{ stockIdForm.gold_price }}</span>
                    </el-form-item>
                    <el-form-item label="其他费用：">
                        <span>{{ stockIdForm.point }}</span>
                    </el-form-item>
                    <el-form-item label="裸石成本：">
                        <span>{{ stockIdForm.diamond_cost }}</span>
                    </el-form-item>
                    <el-form-item label="戒托成本：">
                        <span>{{ stockIdForm.rings_cost }}</span>
                    </el-form-item>
                    <el-form-item label="成本：">
                        <span>{{ stockIdForm.rmb_cost }}</span>
                    </el-form-item>
                    <el-form-item label="状态：">
                        <span>{{ stockIdForm.sale_status }}</span>
                    </el-form-item>
                    <el-form-item label="客户：">
                        <span>{{ stockIdForm.clients }}</span>
                    </el-form-item>
                    <el-form-item label="备注：">
                        <span>{{ stockIdForm.remark }}</span>
                    </el-form-item>
                    -->
                </el-form>
                <div class="text e-info auto-table">
                    <el-table :data="diamondInfoList" stripe  size="big"
                        ref="refTable" height='600px'
                        :header-cell-style="{background:'#eef1f6',color:'black',fontSize:'12px',padding:'0 0',margin:'0 0'}" 
                        :row-style="{height:'12px',color:'black',fontSize:'13px',padding:'0 0',margin:'0 0'}">
                        <el-table-column type="selection" width="45" align="center"></el-table-column>
                        <!--
                        <el-table-column align="center" min-width="8%" prop="image_link" label="图片" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <div>
                                    <el-image fit="contain" style="height:20px" v-if="scope.row.image_link !== '' || !scope.row.vedio_link" lazy
                                        :src="scope.row.image_link" :preview-src-list="[scope.row.image_link]">
                                    </el-image>
                                    <div v-if="scope.row.vedio_link" @click="openVideoDialog(scope.row.vedio_link)" style="cursor:pointer">
                                        <i class="el-icon-video-camera" style="font-size: 20px; color: #409EFF;"></i>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" min-width="9%" prop="sale_status" label="钻石状态"></el-table-column>
                        <el-table-column align="center" min-width="8%" prop="remark" label="备注"></el-table-column>
                        <el-table-column align="center" min-width="6%" prop="place" label="地点"></el-table-column>
                        -->
                        <el-table-column align="center" min-width="8%" prop="shape" label="形状"></el-table-column>
                        <el-table-column align="center" min-width="8%" prop="ct" label="重量" :render-header="renderHeader" sortable></el-table-column>
                        <el-table-column align="center" min-width="6%" prop="col" label="颜色"></el-table-column>
                        <el-table-column align="center" min-width="7%" prop="cla" label="净度"></el-table-column>
                        <el-table-column align="center" min-width="6%" prop="cut" label="切工"></el-table-column>
                        <el-table-column align="center" min-width="6%" prop="pol" label="抛光"></el-table-column>
                        <el-table-column align="center" min-width="6%" prop="sym" label="对称"></el-table-column>
                        <el-table-column align="center" min-width="6%" prop="fl" label="荧光"></el-table-column>
                        <el-table-column align="center" min-width="13%" prop="cert_no" label="证书号" show-overflow-tooltip></el-table-column>
                        <el-table-column align="center" min-width="15%" prop="meas" label="尺寸"></el-table-column>
                        <el-table-column align="center" min-width="6%" prop="year" label="年份"></el-table-column>
                        <el-table-column align="center" min-width="8%" prop="sale_rap" label="Rap"></el-table-column>
                        <el-table-column align="center" min-width="8%" prop="new_dis" label="折扣" :render-header="renderHeader" sortable></el-table-column>
                        <el-table-column align="center" min-width="12%" prop="sale_price" label="RMB" :render-header="renderHeader" sortable show-overflow-tooltip></el-table-column>
                        <el-table-column align="center" min-width="8%" prop="rating" label="评价"></el-table-column>
                        
                    </el-table>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="批量删除" :visible.sync = "dialogTableVisible8" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <span>是否确认进行批量删除操作</span>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogTableVisible8 = false">取消</el-button>
                    <el-button type="primary" @click="deleteProduceInfo">确认</el-button>
                </div>
            </el-dialog>
        </div>
        <div class="text e-info auto-table">
            <el-dialog title="批量更新" :visible.sync = "dialogTableVisible2" @close="closeSava" 
                width="600px" center :close-on-click-modal="false">
                <el-form :inline="true" label-width="150px" size="small" 
                    :model="addDataForm2" class="demo-form-inline" ref="addDataForm2" :rules="rules2">
                    <el-form-item prop="sale_status" label="状态：">
                        <el-select v-model="addDataForm2.sale_status" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in sale_statusList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="clients" label="客户：">
                        <el-input v-model="addDataForm2.clients" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="place" label="地点：">
                        <el-select v-model="addDataForm2.place" placeholder="请选择" style="width:180px">
                            <el-option v-for="item in placeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="gold" label="金价：">
                        <el-input v-model="addDataForm2.gold" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item prop="remark1" label="备注：">
                        <el-input v-model="addDataForm2.remark" placeholder="请输入"></el-input>
                    </el-form-item><br>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="savaDataParams1">保存并提交</el-button>
                </div>
            </el-dialog>
        </div>
        <!-- 
            action="https://mn.ldsgia.com/ldspj/produce/uploadFile"
            action="http://192.168.110.145:8080/ldspj/produce/uploadFile"
         -->
        <div class="text e-info auto-table">
            <el-dialog title="上传文件" :visible.sync = "dialogTableVisible001" @close="closeSava" 
                width="1000px" center :close-on-click-modal="false">
                <div class="search-content mar_b">
                    <el-upload class="upload-demo" 
                            name = "fileList"
                            ref="upload"
                            action="https://mn.ldsgia.com/ldspj/produce/uploadFile"
                            :auto-upload="false"
                            :data="{user:user}"
                            :multiple="true"
                            :before-upload="beforeUpload"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove">
                        <el-button type="primary" slot="trigger" size="big">选取文件</el-button>
                        <el-button type="success" @click="submitUpload" size="big">批量上传</el-button>
                        <div slot="tip" class="el-upload__tip" style="font-size:20px">只能上传xls/xlsx格式的文件</div>
                    </el-upload>
                </div>
            </el-dialog>
        </div>
        <el-dialog
            title="图片预览"
            :visible.sync="imageDialogVisible"
            width="600px"
            center
            :close-on-click-modal="true"
            :append-to-body="true"
            >
            <div style="text-align:center">
                <el-image
                v-if="currentImageUrl"
                :src="currentImageUrl"
                fit="contain"
                style="max-width:100%;max-height:70vh"
                />
            </div>
        </el-dialog>
        <!-- 视频播放弹窗 -->
        <el-dialog
            title="钻石视频"
            :visible.sync="videoDialogVisible"
            width="600px"
            center
            :close-on-click-modal="true"
            :append-to-body="true">
            <div class="video-dialog-content">
                <video-player
                    v-if="currentVideoUrl"
                    class="full-video-player" 
                    ref="fullVideoPlayer"
                    :options="getFullVideoOptions(currentVideoUrl)"
                    :playsinline="true">
                </video-player>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import util from '../../common/js/util';
    export default {
        data() {
            return {
                usertype:'',
                isAble: true,
                dialogTableVisible2: false,
                dialogTableVisible10: false,
                dialogTableVisible8: false,
                dialogTableVisible001: false,
                checkboxGroup12: [],
                checkboxGroup9: [],
                diamondInfoList: [],
                fileList: [],
                typeList: [{'value':'耳钉'},{'value':'排戒'},{'value':'手链'},{'value':'套链'},{'value':'满圈排戒'}],
                placeList: [{'value':'HK'},{'value':'SZ'},{'value':'CN'},{'value':'SH'},{'value':'H-K'}],
                sale_statusList: [{'value':'在售'},{'value':'保留'},{'value':'借货'}
                            ,{'value':'全款借货'},{'value':'已完成'}],
                isq: '',
                inv_status: '',
                addDataForm: {},
                addDataForm2: {},
                idList: [],
                dataOnLineListSelections: [],
                certnoList: [],
                certnoStr: '',
                produceInfoList: [],
                produceAllInfoList: [],
                data_len: 0,
                sale_rap_total: 0,
                sale_usd_total: 0,
                sale_price_total: 0,
                caozuo: '新增',
                user:'admin',
                diamond_num: 0,
                // 视频弹窗数据
                videoDialogVisible: false,
                currentVideoUrl: '',
                // 图片弹窗数据
                imageDialogVisible: false,
                currentImageUrl: '',
                // 查询
                query: {
                    data_dt: [],
                    ct1: '',
                    ct2: '',
                    danhao: '1',
                    huiyuan: '1'
                },
                queryDate: '',
                // queryDate: this.getNowTime(),
                // 分页
                pager: {
                    page: 1,
                    rows: 20,
                    total: 0
                },
                rules:{
                    stock_id:[
                        {
                            required:true,
                            message:'请输入',
                            trigger:'blur'
                        }
                    ]
                },
                rules2:{
                    /*sale_status:[
                        {
                            required:true,
                            message:'请选择',
                            trigger:'blur'
                        }
                    ]*/
                },
                stockIdDialogVisible: false,
                stockIdForm: {},
            };
        },
        methods: {
            // 销售状态
            checkboxChange9(val) {
                this.query.sale_status = val.join();
                //console.log(this.query.sale_status);
            },
            // 库存状态
            checkboxChange11(val) {
                this.query.inv_status = val.join();
                //console.log(this.query.inv_status);
            },
            // 地点
            checkboxChange12(val) {
                this.query.place = val.join();
                //console.log(this.query.place);
            },
            // 选择行数
            sizeChange(rows) {
                this.pager.rows = rows;
                this.selectList();
            },
            // 选择页
            pageChange(page) {
                this.pager.page = page;
                this.selectList();
            },
            // 选择器选择数据，加工数据证书号
            selectionLineChangeHandle(val) {
                // 统计选中数量
                this.data_len = val.length;
                // 选中导出数据赋值
                this.dataOnLineListSelections = val;
                this.certnoList = val.map((item) => item.stock_id + '\n');
                //数据选中后，显示按钮
                if(val.length>0) {
                    this.isAble = false;
                }else{
                    this.isAble = true;
                }
                this.idList = val.map((item) => item.id);
            },
            // 获取货号
            selectCertno() {
                this.certnoStr = this.certnoList.join(',');
                this.certnoStr = this.certnoStr.replaceAll(',','');
                console.log(this.certnoStr);
                // 复制
                this.copyText(this.certnoStr);
            },
            copyText(val){
                // 存储传递过来的数据
                //let userId = sessionStorage.getItem("userId");
                // createElement() 方法通过指定名称创建一个元素
                let newInput = document.createElement('textarea');
                // 讲存储的数据赋值给input的value值
                newInput.value = val;
                // appendChild() 方法向节点添加最后一个子节点
                document.body.appendChild(newInput);
                // select() 方法用于选择该元素中的文本
                newInput.select();
                // execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
                document.execCommand('Copy');
                // 清空输入框
                newInput.remove();
                // 下面是element的弹窗 不需要的自行删除就好
                this.$message({
                    message: "复制成功",
                    type: "success",
                });
            },
            // 修改金价
            handleInput1() {
                // 获取净重、金价、损耗
                let net_weight = parseFloat(this.addDataForm.net_weight) || 0;
                let gold = parseFloat(this.addDataForm.gold) || 0;
                let loss = parseFloat(this.addDataForm.loss) || 0;
                let point = parseFloat(this.addDataForm.point) || 0;
                // 损耗如果是百分比，转为小数
                if (loss > 1) {
                    loss = loss / 100;
                }

                // 计算金料金额 = 金价*净重 *（1+损耗）
                let gold_price = net_weight * gold * (1 + loss);
                // 保留2位小数
                this.addDataForm.gold_price = gold_price ? Math.round(gold_price) : '';

                // 获取
                let diamond_price = parseFloat(this.addDataForm.diamond_price) || 0;
                let rings_price = parseFloat(this.addDataForm.gold_price) + parseFloat(this.addDataForm.point) ;
                this.addDataForm.rings_price = rings_price ? Math.round(rings_price) : '';

                let rmb_cost = parseFloat(diamond_price) + parseFloat(this.addDataForm.rings_price);
                this.addDataForm.rmb_cost = rmb_cost ? Math.round(rmb_cost) : '';

                let sale_price = Math.round(rmb_cost) * parseFloat(1.15);
                this.addDataForm.sale_price = sale_price ? Math.round(sale_price) : '';
            },
            // 修改金价
            handleInput2() {
                // 获取净重、金价、损耗
                let diamond_price = parseFloat(this.addDataForm.diamond_price) || 0;
                let rings_price = parseFloat(this.addDataForm.rings_price) || 0;

                let rmb_cost = parseFloat(diamond_price) + parseFloat(rings_price);
                this.addDataForm.rmb_cost = rmb_cost ? Math.round(rmb_cost) : '';

                let sale_price = Math.round(rmb_cost) * parseFloat(1.15);
                this.addDataForm.sale_price = sale_price ? Math.round(sale_price) : '';
            },
            // 修改成本
            handleInput3() {
                // 获取净重、金价、损耗
                let rmb_cost = parseFloat(this.addDataForm.rmb_cost) || 0;

                let sale_price = Math.round(rmb_cost) * parseFloat(1.15);
                this.addDataForm.sale_price = sale_price ? Math.round(sale_price) : '';
            },
            // 修改订单数据
            savaInfo() {
                let _this = this;
                // 判断表单是否通过了表单验证
                this.$refs.addDataForm.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/produce/savaProduceInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            id: _this.addDataForm.id,
                            stock_id: _this.addDataForm.stock_id,
                            produce_name: _this.addDataForm.produce_name,
                            shape: _this.addDataForm.shape,
                            fenshu: _this.addDataForm.fenshu,
                            type: _this.addDataForm.type,
                            length: _this.addDataForm.length1,
                            material: _this.addDataForm.material,
                            produce_detail: _this.addDataForm.produce_detail,
                            place: _this.addDataForm.place,
                            weight: _this.addDataForm.weight,
                            net_weight: _this.addDataForm.net_weight,
                            diamond_weight: _this.addDataForm.diamond_weight,
                            diamond_num: _this.addDataForm.diamond_num,
                            gold: _this.addDataForm.gold,
                            loss: _this.addDataForm.loss,
                            gold_price: _this.addDataForm.gold_price,
                            diamond_cost: _this.addDataForm.diamond_cost,
                            diamond_price: _this.addDataForm.diamond_price,
                            rings_cost: _this.addDataForm.rings_cost,
                            rings_price: _this.addDataForm.rings_price,
                            rmb_cost: _this.addDataForm.rmb_cost,
                            sale_price: _this.addDataForm.sale_price,
                            sale_status: _this.addDataForm.sale_status,
                            clients: _this.addDataForm.clients,
                            remark: _this.addDataForm.remark,
                            upload_date: _this.addDataForm.upload_date,
                            deal_date: _this.addDataForm.deal_date,
                            caozuo: _this.caozuo
                        }, function (res) {
                            if (res.flag) {
                                _this.successMsg('本次操作成功！');
                                _this.dialogTableVisible10 = false;
                                _this.selectList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        });
                    } else { // 否则返回
                        return false;
                    }
                });
            },
            // 打开图片弹窗
            openImageDialog(url) {
                this.currentImageUrl = url;
                this.imageDialogVisible = true;
            },
            // 打开视频弹窗
            openVideoDialog(videoUrl) {
                this.currentVideoUrl = videoUrl;
                this.videoDialogVisible = true;
            },
            // 大视频配置
            getFullVideoOptions(video_link) {
                return {
                    playbackRates: [0.5, 1.0, 1.5, 2.0],
                    autoplay: true,
                    muted: false,
                    loop: true,
                    preload: 'auto',
                    language: 'zh-CN',
                    aspectRatio: '4:3',
                    fluid: true,
                    sources: [{
                        type: 'video/mp4',
                        src: video_link
                    }],
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: true,
                        fullscreenToggle: true
                    }
                };
            },
            // 前端处理 导出选中数据
            exportSelect() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['货号','名称','形状','大小','详细参数','钻石总重', '品类', '尺寸', '材质', '总重', '售价']
                    const filterVal = ['stock_id','produce_name','shape','fenshu','produce_detail','diamond_weight', 'type', 'length', 'material', 'weight', 'sale_price']
                    const list = this.dataOnLineListSelections
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '货品信息')
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            // 查询全部数据用于CSV导出
            exportAllList() {
                let _this = this;
                _this.showMsg("正在导出数据，请勿重复操作！");
                util.publicget('/produce/queryProduceInfoListByCondition', {
                }, function (res) {
                    if (res.flag) {
                        if(res.obj.length>0) {
                            _this.produceAllInfoList = res.obj;
                            _this.exportAll();
                        }else {
                            _this.errorMsg("导出失败！");
                        }
                    } else {
                        _this.errorMsg("导出失败！");
                    }
                });
            },
            // 导出全部数据
            exportAll() {
                //let res =[{name:'小白',age:'18'},{name:'小黑',age:'16'}]
                require.ensure([], () => {
                    const { export_json_to_excel } = require('../../common/js/Export2Excel.js')
                    const tHeader = ['货号','名称','形状','大小','详细参数','钻石总重', '品类', '尺寸', '材质', '总重', '售价']
                    const filterVal = ['stock_id','produce_name','shape','fenshu','produce_detail','diamond_weight', 'type', 'length', 'material', 'weight', 'sale_price']
                    const list = this.produceAllInfoList
                    const data = this.formatJson(filterVal, list)
                    export_json_to_excel(tHeader, data, '货品信息')
                })
            },
            // 修改数据状态
            savaDataParams1() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                if(!_this.addDataForm2.sale_status && !_this.addDataForm2.place 
                    && !_this.addDataForm2.clients && !_this.addDataForm2.remark
                    && !_this.addDataForm2.gold){
                    _this.errorMsg('请填写状态、地点、客户、备注、金价中的至少一个！');
                    return;
                }
                this.$refs.addDataForm2.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/produce/savaProduceInfoStatus', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            sale_status: _this.addDataForm2.sale_status,
                            clients: _this.addDataForm2.clients,
                            remark: _this.addDataForm2.remark,
                            place: _this.addDataForm2.place,
                            gold: _this.addDataForm2.gold,
                            id: _this.idStr
                        }, function (res) {
                            if (res.flag) {
                                // console.log(res);
                                _this.successMsg(res.msg);
                                _this.dialogTableVisible2 = false;
                                _this.selectList();
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        })
                    }
                });
            },
            // 加载产品信息分页列表
            selectList() {
                let _this = this;
                util.publicget('/produce/queryProduceListPageModel', {
                    stock_id: _this.query.stock_id,
                    produce_name: _this.query.produce_name,
                    shape: _this.query.shape,
                    fenshu: _this.query.fenshu,
                    material: _this.query.material,
                    type: _this.query.type,
                    place: _this.query.place,
                    sale_status: _this.query.sale_status,
                    clients: _this.query.clients,
                    remark: _this.query.remark,
                    upload_date: _this.query.upload_date,
                    deal_date: _this.query.deal_date,
                    pageNo: _this.pager.page,
                    pageSize: _this.pager.rows
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.pager.total = res.count || 0;
                        _this.produceInfoList = res.obj;
                    } else {
                        _this.errorMsg('本次操作失败');
                    }
                });
            },
            // dialog 关闭，数据清空
            closeSava() {
                this.dialogTableVisible10 = false;
                this.addDataForm = {};
                this.addDataForm2 = {};
                //this.selectList();
            },
            // 加载查询订单单条记录
            selectProduceList(rows) {
                let _this = this;
                util.publicget('/produce/queryProduceInfoListByCondition', {
                    equalsId: rows.id
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.addDataForm = res.obj[0];
                            _this.dialogTableVisible10 = true;
                            _this.caozuo = '修改';
                        }else {
                            _this.showMsg("数据不存在");
                        }
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 新增产品
            insertProduceInfo() {
                let _this = this;
                _this.addDataForm = {};
                _this.dialogTableVisible10 = true;
                _this.caozuo = '新增';
            },
            // 删除数据
            deleteProduceInfo() {
                let _this = this;
                _this.idStr = _this.idList.join(',');
                util.publicget('/produce/deleteProduceInfoByCondition', {
                    // user: document.cookie.split(';')[1].split('=')[1],
                    user: sessionStorage.getItem('userName'),
                    id: _this.idStr
                }, function (res) {
                    if (res.flag) {
                        // console.log(res);
                        _this.successMsg(res.msg);
                        _this.dialogTableVisible8 = false;
                        _this.selectList();
                    } else {
                        _this.errorMsg(res.msg);
                        _this.dialogTableVisible8 = false;
                    }
                });
            },
            // 取消
            resetForm(formName) {
                this.checkboxGroup9 = [];
                this.checkboxGroup12 = [];
                this.$refs[formName].resetFields();
                this.query = {};
            },
            // 时间格式化
            formatterDate(row, column) {
                return util.formatDate.format(new Date(row.start_date), 'yyyy-MM-dd');
            },
            getNowTime() {
                var now = new Date();
                var year = now.getFullYear();
                var month = now.getMonth();
                var date = now.getDate();
                month = month + 1;
                month = month.toString().padStart(2, '0');
                date = date.toString().padStart(2, '0');
                var defaultDate = `${year}-${month}-${date}`;
                return defaultDate;
            },
            handleStockIdClick(row) {
                let _this = this;
                _this.stockIdForm = { ...row };
                _this.stockIdDialogVisible = true;
                
                util.publicget('/diamond/queryDaimondList', {
                    equalsStock_id: row.stock_id
                }, function (res) {
                    if (res.flag) {
                        //console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.diamondInfoList = res.obj;
                            _this.diamond_num = res.obj.length;
                        }
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            closeStockIdDialog() {
                this.stockIdDialogVisible = false;
                this.stockIdForm = {};
                this.diamondInfoList = [];
            },
            // 上传货品
            handleSuccess(res, file) {
                if (res.flag) {
                    if (res.code === 200) {
                        this.successMsg(res.msg);
                    }else if (res.code === 201) {
                        this.showMsg(res.msg);
                    }
                }else{
                    this.errorMsg(res.msg);
                }
                // console.log(res);
            },
            handleError(res, file){
                this.errorMsg('上传失败');
                // console.log(res);
                if ("502" == res.code) {
                    this.$router.push('/login');
                }
            },
            handlePreview(file) {
                console.log(file);
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            beforeUpload(file) {
                const extension = file.name.split(".")[1] === "xls";
                const extension2 = file.name.split(".")[1] === "xlsx";
                if (!extension && !extension2) {
                    alert('上传附件只能是xls/xlsx格式！');
                    return false;
                }
            },
            submitUpload() {
                // 第一种上传 ref
                this.$refs.upload.submit();
                this.fileList = [];
            },
            renderHeader (h, {column, $index }) {
                if (column.order == 'ascending') {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort-up'
                            })
                        ]
                    )
                }else if (column.order == 'descending') {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort-down'
                            })
                        ]
                    )
                } else {
                    return h(
                        'div',
                        [
                            h('span',column.label),
                            h('i',{
                                class:'el-icon-sort'
                            })
                        ]
                    )
                }
            }
        },
        mounted() {
            this.usertype= sessionStorage.getItem('userType');
            this.selectList();
        }
    };
</script>

<style lang="scss">
    /*
    ::v-deep .el-table__expand-icon {
        display: none !important;
    }*/
    .el-dialog .el-dialog__body{
        flex: 1;
        overflow: auto;
    }
     /*:header-cell-style="{background:'#eee8aa'}"
    .el-table--border:after,
    .el-table--group:after,
    .el-table:before{
        background-color: #eee8aa
    }

    .el-table--border,
    .el-table--group{
        border-color: #eee8aa
    }

    .el-table td,
    .el-table th.is-leaf{
        border-bottom: #eee8aa
    }

    .el-table--border th,
    .el-table--border th.gutter:last-of-type{
        border-bottom: #eee8aa
    }

    .el-table--border td,
    .el-table--border th{
        border-right: #eee8aa
    }
    */
</style>



// WEBPACK FOOTER //
// src/pages/produce/produceInfoList.vue